// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-new {
  padding: 0px 12px;
  height: 32px;
  min-width: 65px;
  border-radius: 3px;
  font-size: 13px;
  line-height: 32px;
  cursor: pointer;
  text-align: center;
  box-sizing: border-box;
}

.button-new.primary-button {
  color: #ffffff;
  background-color: var(--main-font-color);
}
.button-new.primary-button:hover {
  background-color: var(--main-font-color);
}
.button-new.primary-button.disable {
  background-color: #b9c2cb;
  cursor: not-allowed;
  pointer-events: none;
}

.button-new.secondary-button {
  color: var(--main-font-color);
  background-color: #ffffff;
  border: 1px solid var(--main-font-color);
  font-weight: 500;
}
.button-new.secondary-button:hover {
  background-color: #f9f9fa;
}
.button-new.secondary-button.disable {
  border: 1px solid #b9c2cb;
  background-color: #ffffff;
  color: #b9c2cb;
  cursor: default;
}

.button-new.link-button {
  color: #4285f4;
  background-color: inherit;
}
.button-new.link-button:hover {
  background-color: #f9f9fa;
}
.button-new.link-button.disable {
  color: #b9c2cb;
  cursor: default;
  background-color: inherit;
}

.button_simulate_loader {
  width: 110px;
  height: 40px;
  position: relative;
  margin: auto;
}
.button_simulate_loader .loader {
  position: relative;
  margin: auto;
  border: 16px solid #3498db;
  border-radius: 50%;
  border-top: 16px solid #f3f3f3;
  width: 10px;
  height: 10px;
  -webkit-animation: spin 1s linear infinite;
  animation: spin 1s linear infinite;
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui-core/src/components/Button/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kCAAkC;AACpC","sourcesContent":[".button-new {\n  padding: 0px 12px;\n  height: 32px;\n  min-width: 65px;\n  border-radius: 3px;\n  font-size: 13px;\n  line-height: 32px;\n  cursor: pointer;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n.button-new.primary-button {\n  color: #ffffff;\n  background-color: var(--main-font-color);\n}\n.button-new.primary-button:hover {\n  background-color: var(--main-font-color);\n}\n.button-new.primary-button.disable {\n  background-color: #b9c2cb;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.button-new.secondary-button {\n  color: var(--main-font-color);\n  background-color: #ffffff;\n  border: 1px solid var(--main-font-color);\n  font-weight: 500;\n}\n.button-new.secondary-button:hover {\n  background-color: #f9f9fa;\n}\n.button-new.secondary-button.disable {\n  border: 1px solid #b9c2cb;\n  background-color: #ffffff;\n  color: #b9c2cb;\n  cursor: default;\n}\n\n.button-new.link-button {\n  color: #4285f4;\n  background-color: inherit;\n}\n.button-new.link-button:hover {\n  background-color: #f9f9fa;\n}\n.button-new.link-button.disable {\n  color: #b9c2cb;\n  cursor: default;\n  background-color: inherit;\n}\n\n.button_simulate_loader {\n  width: 110px;\n  height: 40px;\n  position: relative;\n  margin: auto;\n}\n.button_simulate_loader .loader {\n  position: relative;\n  margin: auto;\n  border: 16px solid #3498db;\n  border-radius: 50%;\n  border-top: 16px solid #f3f3f3;\n  width: 10px;\n  height: 10px;\n  -webkit-animation: spin 1s linear infinite;\n  animation: spin 1s linear infinite;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
